export interface RecordCategoryDto {
    recordId: number;
    categoryName: string;
    remarks?: string;
    userId: number;
    dateInserted: string;
}
export const recordCategoryKeyId = "recordId" as const;

export const recordCategoryFields = [
    { name: "categoryName", label: "Όνομα Κατηγορίας", type: "text", required: true },
    { name: "remarks", label: "Παρατηρήσεις", type: "text", required: false },
    { name: "userId", label: "ID Χρήστη", type: "number", required: true },
    { name: "dateInserted", label: "Ημερομηνία Εισαγωγής", type: "date", required: true },
] as const;

export const recordCategoryFilters = recordCategoryFields.filter(f => 
  ["categoryName", "remarks"].includes(f.name));

export const recordCategoryFormData: string[] = ["categoryName", "remarks"];